import { makeStyles } from '@material-ui/core/styles';

export const useProductContainerMobileStyles = makeStyles(() => ({
  container: {
    border: '1px solid #d9d9d9',
    borderColor: (props) => props.color,
    padding: '26px 0px 29px 28px',
    '& :not(:last-child)': {
      marginRight: 13,
    },
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
}));

export const useProductImageMobileStyles = makeStyles(() => ({
  image: {
    height: 88,
    width: 88,
    objectFit: 'cover',
  },
  icon: {
    height: 30,
    width: 30,
  },
}));

export const useProductInformationStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 700,
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  subtitle: {
    fontSize: 14,
  },
  subtitleWeight: {
    fontWeight: 600,
  },
  container: {
    '& :not(:last-child)': {
      marginBottom: 6,
    },
  },
}));
